export default __webpack_public_path__ + "static/media/arrow_toggle.05fe6974.svg";